import '@fontsource-variable/roboto'

import { loadEnvironment } from './Common/environment'

loadEnvironment()
    .catch(() => undefined)
    .then(() => import('./Common/base/initApp'))
    .then(({ default: initApp }) => initApp())
